import type { Route } from '../admin-fetch';
import { ADMIN_API, bodyOf, call, failure, seg, toResponse } from '../respond';

// Admin accounts. Adding, deleting and resetting are owner-only — the
// server enforces that, and refuses deleting yourself or the last owner.

const TEAM = `${ADMIN_API}/team`;

export const teamRoutes: Route[] = [
  ['GET', '/api/settings/team', async () => toResponse(await call('GET', TEAM), 'admins')],
  ['POST', '/api/settings/team', async (req) => toResponse(await call('POST', TEAM, await bodyOf(req)), 'admin', 201)],
  ['DELETE', '/api/settings/team/:id', async (_req, { id }) => {
    const result = await call('DELETE', `${TEAM}/${seg(id)}`);
    return result.ok ? Response.json({ success: true }) : failure(result);
  }],
  ['POST', '/api/settings/team/:id/reset-password', async (req, { id }) => {
    const { password } = await bodyOf<{ password?: string }>(req);
    const result = await call('POST', `${TEAM}/${seg(id)}/reset-password`, { password: password ?? '' });
    return result.ok ? Response.json({ success: true }) : failure(result);
  }],
];
